module.exports = __webpack_public_path__ + "static/icon_life_saving_gift_process_03@2x-75560da957cb298f4b196dc05f3c2fa0.png";